import { render, staticRenderFns } from "./InternalNews.vue?vue&type=template&id=b534516e&"
import script from "./InternalNews.vue?vue&type=script&lang=js&"
export * from "./InternalNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports